import { render, staticRenderFns } from "./PaymentAttributeEdit.vue?vue&type=template&id=2cdbf964"
import script from "../../controllers/payment_attribute/payment-attribute-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/payment_attribute/payment-attribute-edit.js?vue&type=script&lang=js&external"
import style0 from "./PaymentAttributeEdit.vue?vue&type=style&index=0&id=2cdbf964&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports